import { S1Endpoint } from 'common/graphqlTypes';
import { ICON_COLORS } from 'styles/stylesProvider/themes';
import { schema as sentinelOneSchema } from 'schemas/sentinel-one/schema';
import { IconMap } from 'plugins/types';

/**
 * @description This method calculate the endpoints icon by endpointData.
 *  @param      endpointData the data of the endpoint.
 *  @returns    endpoints icon color.
 * */
export const getEndpointIcon = (endpointData: S1Endpoint): string => {
  let iconClass = '';
  const osIconMapper = sentinelOneSchema.fields['endpoint.os'].icon as IconMap;
  const osTypeIcon = osIconMapper[endpointData?.osType] || '';
  const isKubernetesMachineType =
    endpointData.machineType?.length > 0 && endpointData.machineType.includes('kubernetes');

  if (isKubernetesMachineType) {
    iconClass = `kubernetes-${osTypeIcon}`;
    if (endpointData.isDecommissioned) {
      iconClass = `${iconClass}-disable`;
    }
  } else if (endpointData.isDecommissioned) {
    iconClass = 'decomission';
  } else if (endpointData.machineType === 'storage') {
    iconClass = 'ranger_storage';
  } else {
    if (endpointData.machineType !== 'unknown') {
      iconClass = `${endpointData.machineType}-`;
    }
    iconClass = `${iconClass}${osTypeIcon}`;
  }

  return iconClass;
};

/**
 * @description This method calculate the endpoints icon color by endpointData.
 *  @param      endpointData the data of the endpoint.
 *  @returns    endpoints icon color.
 * */
export function getEndpointIconColor(endpointData: S1Endpoint): ICON_COLORS {
  if (endpointData.threatCount > 0 || (endpointData.isActive && endpointData.infected)) {
    return ICON_COLORS.INFECTED_ENDPOINT;
  }
  if (!endpointData.isActive) {
    return !endpointData.infected ? ICON_COLORS.INACTIVE_ENDPOINT : ICON_COLORS.INACTIVE_THREAT_ACTIVE_ENDPOINT;
  }

  return ICON_COLORS.ENDPOINT;
}

/**
 * @description   this method create the endpoint type text.
 *  @param        endpointData the data of the endpoint.
 *  @returns      a string of endpoint type.
 * */
export function getEndpointType(endpointData: S1Endpoint): string {
  if (endpointData.machineType !== 'storage') {
    const revisionToShow =
      !endpointData.osRevision || ['windows', 'windows_legacy'].includes(endpointData.osType)
        ? ''
        : ' ' + endpointData.osRevision;
    const osArch = endpointData.osArch ? ' (' + endpointData.osArch + ')' : '';
    return `${endpointData.osName || ''}${revisionToShow}${osArch}`;
  }

  const suffix = `${endpointData.storageName && endpointData.storageType ? ` (${endpointData.storageType})` : ''}`;

  return `${endpointData.storageName || ''}${suffix}`;
}

/**
 * @description   this method create the endpoint scope text.
 *  @param        endpointData the data of the endpoint.
 *  @returns      a string of endpoint scope.
 * */
export function getEndpointScope(endpointData: S1Endpoint): string {
  return `${endpointData.accountName} / ${endpointData.siteName} / ${endpointData.groupName}`;
}
